import React, { useState } from 'react';
import { Grid, Box, useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import MenuIcon from '@material-ui/icons/Menu';

import Button from '../../components/Button';
import Drawer from '../../components/Drawer';
import NavList from '../../components/NavList';
import { logout } from '../../store/thunks/auth-thunks';

import Logo from '../../images/careplix-logo.png';

const setNavList = (
  isLoggedIn,
  classes,
  { push = () => {}, logout = () => {}, registerBtnObj = {} },
) => {
  const navList = isLoggedIn
    ? [
        {
          key: '1',
          to: '/bookings',
          linkText: 'All Bookings',
        },
        {
          key: '2',
          to: '/profile',
          linkText: 'Profile',
        },
        {
          key: '3',
          to: '/packages',
          linkText: 'Packages',
        },
        {
          key: '4',
          component: (
            <Button
              variant="text"
              backgroundTransparent
              disableElevation
              disableFocusRipple
              disableRipple
              classes={{ text: classes.LogoutButton }}
              onClick={logout}
            >
              Logout
            </Button>
          ),
        },
      ]
    : [
        {
          key: '5',
          to: '/login',
          linkText: 'Consult Doctors',
        },
        {
          key: '6',
          to: '',
          linkText: 'Vitals Monitoring',
        },
        {
          key: '7',
          to: '',
          linkText: 'Healthpass',
        },
        {
          key: '8',
          to: '',
          linkText: 'Our Devices',
        },
        registerBtnObj,
      ];

  return navList;
};

const Header = () => {
  const classes = useStyles();
  const { push } = useHistory();

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const authToken = useSelector((state) => state.auth.authToken);
  const dispatch = useDispatch();

  const breakPointBelow620p = useMediaQuery('(max-width:620px)');
  const breakPointBelow780p = useMediaQuery('(max-width:780px)');
  const breakPointBelow1150p = useMediaQuery('(max-width:1150px)');

  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleButton = {
    key: 'toggle-menu-button',
    component: (
      <Button
        variant="contained"
        color="primary"
        className={classes.ToggleMenuBtn}
        onClick={setDrawerOpen.bind(null, true)}
      >
        <MenuIcon fontSize="inherit" />
      </Button>
    ),
  };

  const registerBtnObj = {
    key: '9',
    component: (
      <Button
        variant="contained"
        color="primary"
        className={classes.RegisterBtn}
        onClick={() => push('/')}
      >
        Register
      </Button>
    ),
  };

  const navList = setNavList(isLoggedIn, classes, {
    push,
    logout: () => dispatch(logout(authToken)),
    registerBtnObj,
  });

  let navListInDrawer = [];
  let navListInHeader = [];
  if (!isLoggedIn) {
    navListInHeader = breakPointBelow1150p
      ? breakPointBelow620p
        ? [toggleButton]
        : [registerBtnObj, toggleButton]
      : navList;
    navListInDrawer = breakPointBelow1150p
      ? breakPointBelow620p
        ? navList
        : navList.slice(0, navList.length - 1)
      : [];
  } else {
    navListInHeader = breakPointBelow780p ? [toggleButton] : navList;
    navListInDrawer = breakPointBelow780p ? navList : [];
  }

  return (
    <React.Fragment>
      {navListInDrawer.length > 0 ? (
        <Drawer
          open={drawerOpen}
          drawerChildren={<NavList vertical={true} navList={navListInDrawer} />}
          onClose={setDrawerOpen.bind(null, false)}
        />
      ) : null}

      <Box className={classes.Topheader}>
        <Grid container spacing={3}>
          <Grid item xs={3} style={{ display: 'flex', alignItems: 'center' }}>
            <Link to="/" className={classes.Logo}>
              <img src={Logo} alt="Logo" className={classes.LogoImage} />
            </Link>
          </Grid>

          <Grid item xs={9}>
            <Box className={classes.RightNav}>
              <NavList vertical={false} navList={navListInHeader} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
};

export default Header;

const useStyles = makeStyles((theme) => ({
  Topheader: {
    width: '100%',
    position: 'fixed',
    left: '0px',
    top: '0',
    padding: '0 5%',
    height: '80px',
    background: '#fff',
    zIndex: '999',
    fontSize: theme.typography.pxToRem(16),
  },
  RightNav: {
    paddingRight: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
    '@media (max-width:780px)': {
      paddingRight: '0px',
    },
  },
  ToggleMenuBtn: {
    minWidth: 0,
    width: theme.typography.pxToRem(50),
    height: theme.typography.pxToRem(50),
    fontSize: theme.typography.pxToRem(30),
    padding: 0,
    borderRadius: '50%',
  },
  LogoImage: {
    width: theme.typography.pxToRem(200),
  },
  RegisterBtn: {
    width: '171px',
    fontSize: 'inherit',
    // background: '#1021b4',
  },
  LogoutButton: {
    textTransform: 'capitalize',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    color: '#000',
    padding: '0',
    minWidth: '0',
  },
}));
